<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <!-- 搜索区域 -->
          <div class="search-con search-con-top">
            <Input
              class="search-input"
              v-model="searchVal"
              style="padding:5px; width: 300px;"
              placeholder="输入培训/鉴定名称、编码搜索"
              @on-enter="handleSearch"
              clearable
            />
            <Select v-model="typeVal" style="width: 120px; margin-left: 10px" placeholder="类型" clearable>
              <Option value="0">培训</Option>
              <Option value="1">鉴定</Option>
            </Select>
            <Button type="primary" icon="ios-search" @click="handleSearch" class="search-btn">搜索</Button>
            <Button type="primary" icon="ios-add" @click="showAddModal" class="search-btn">新增培训鉴定</Button>
            <Button type="success" icon="ios-cloud-upload" @click="showImportModal" class="search-btn">导入</Button>
            <Button type="warning" icon="ios-download-outline" @click="handleExport" class="search-btn">导出</Button>
            <Button type="info" icon="ios-download-outline" @click="handleDownloadTemplate" class="search-btn">下载模板</Button>
          </div>

          <Spin size="large" fix v-if="spinShow"></Spin>

          <!-- 数据表格 -->
          <Table
            ref="trainTable"
            :columns="columns"
            :data="tableData"
            :loading="loading"
            border
            size="small"
          >
          </Table>

          <!-- 分页 -->
          <div class="pagination-con">
            <Page
              :total="total"
              :page-size="pageSize"
              :current="currentPage"
              show-sizer
              show-total
              @on-change="handlePageChange"
              @on-page-size-change="handlePageSizeChange"
            />
          </div>
        </Card>
      </i-col>
    </Row>

    <!-- 新增/编辑模态框 -->
    <Modal
      v-model="formModal.visible"
      :title="formModal.title"
      :loading="formModal.loading"
      :footer-hide="true"
      :mask-closable="false"
      width="600"
    >
      <Form ref="trainForm" :model="formData" :rules="formRules" :label-width="120">
        <FormItem label="培训/鉴定名称" prop="trainname">
          <Input v-model="formData.trainname" placeholder="请输入培训/鉴定名称" />
        </FormItem>
        <FormItem label="培训/鉴定地址" prop="trainaddress">
          <Input v-model="formData.trainaddress" placeholder="请输入培训/鉴定地址" />
        </FormItem>
        <FormItem label="编码" prop="code">
          <Input v-model="formData.code" placeholder="请输入编码" />
        </FormItem>
        <FormItem label="内容" prop="content">
          <Input v-model="formData.content" placeholder="请输入内容" type="textarea" :rows="3" />
        </FormItem>
        <FormItem label="联系人" prop="linkman">
          <Input v-model="formData.linkman" placeholder="请输入联系人" />
        </FormItem>
        <FormItem label="联系电话" prop="phone">
          <Input v-model="formData.phone" placeholder="请输入联系电话" />
        </FormItem>
        <FormItem label="类型" prop="type">
          <Select v-model="formData.type" placeholder="请选择类型" style="width: 100%;">
            <Option value="0">培训</Option>
            <Option value="1">鉴定</Option>
          </Select>
        </FormItem>
        <FormItem label="状态" prop="flag">
          <i-switch v-model="formData.flag" :true-value="0" :false-value="1">
            <span slot="open">有效</span>
            <span slot="close">无效</span>
          </i-switch>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit">提交</Button>
          <Button @click="handleReset" style="margin-left: 8px">重置</Button>
        </FormItem>
      </Form>
    </Modal>

    <!-- 导入模态框 -->
    <Modal
      v-model="importModal.visible"
      title="导入培训鉴定数据"
      :loading="importModal.loading"
      :footer-hide="true"
      width="500"
    >
      <Form ref="importForm" :model="importModal" :rules="importRules" :label-width="80">
        <FormItem label="选择文件" prop="file">
          <Upload
            ref="upload"
            action=""
            :before-upload="handleBeforeUpload"
            accept=".xls, .xlsx"
          >
            <Button icon="ios-cloud-upload">选择Excel文件</Button>
          </Upload>

          <div v-if="importModal.fileName" class="file-name">
            已选择文件: {{ importModal.fileName }}
          </div>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleImport" :disabled="!importModal.fileName">导入</Button>
          <Button @click="handleCancelImport" style="margin-left: 8px">取消</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import {
  getTrainList,
  createTrain,
  updateTrain,
  deleteTrain,
  importTrain,
  exportTrain
} from '@/api/train/train.js'

export default {
  name: 'TrainManage',
  data () {
    return {
      spinShow: false,
      loading: false,
      searchVal: '',
      typeVal: '',
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,

      // 表单模态框
      formModal: {
        visible: false,
        title: '新增培训鉴定',
        loading: false,
        isEdit: false
      },

      // 表单数据
      formData: {
        id: null,
        trainname: '',
        trainaddress: '',
        latitude: '',
        longitude: '',
        code: '',
        content: '',
        linkman: '',
        type: 0,
        phone: '',
        flag: 0
      },

      // 表单验证规则
      formRules: {
        trainname: [
          { required: true, message: '培训/鉴定名称不能为空', trigger: 'blur' },
          { max: 50, message: '培训/鉴定名称长度不能超过50个字符', trigger: 'blur' }
        ],
        trainaddress: [
          { required: true, message: '培训/鉴定地址不能为空', trigger: 'blur' },
          { max: 50, message: '培训/鉴定地址长度不能超过50个字符', trigger: 'blur' }
        ],
        code: [
          { max: 50, message: '编码长度不能超过50个字符', trigger: 'blur' }
        ],
        content: [
          { max: 50, message: '内容长度不能超过50个字符', trigger: 'blur' }
        ],
        linkman: [
          { max: 50, message: '联系人长度不能超过50个字符', trigger: 'blur' }
        ],
        phone: [
          { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号码', trigger: 'blur' }
        ]
      },

      // 导入模态框
      importModal: {
        visible: false,
        loading: false,
        file: null,
        fileName: ''
      },

      // 导入表单验证规则
      importRules: {
        file: [
          { required: true, message: '请选择Excel文件', trigger: 'change' }
        ]
      },

      // 表格列配置
      columns: [
        {
          title: '培训/鉴定名称',
          key: 'trainname',
          minWidth: 150,
          tooltip: true
        },
        {
          title: '地址',
          key: 'trainaddress',
          minWidth: 150,
          tooltip: true
        },
        {
          title: '编码',
          key: 'code',
          width: 120,
          tooltip: true
        },
        {
          title: '内容',
          key: 'content',
          minWidth: 200,
          tooltip: true
        },
        {
          title: '联系人',
          key: 'linkman',
          width: 100,
          tooltip: true
        },
        {
          title: '联系电话',
          key: 'phone',
          width: 120,
          tooltip: true
        },
        {
          title: '类型',
          key: 'type_cn',
          width: 100,
          align: 'center'
        },
        {
          title: '状态',
          key: 'flag',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: params.row.flag === 0 ? 'success' : 'default'
              }
            }, params.row.flag === 0 ? '有效' : '无效')
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            const buttons = [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '5px' },
                on: { click: () => this.showEditModal(params.row) }
              }, '编辑'),
              h('Button', {
                props: { type: 'error', size: 'small' },
                on: { click: () => this.handleDelete(params.row) }
              }, '删除')
            ]
            return h('div', buttons)
          }
        }
      ]
    }
  },

  computed: {
    // 保留空的 computed，后续可添加其他计算属性
  },

  methods: {
    // 获取培训鉴定列表
    async getList () {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize
        }
        if (this.searchVal) {
          params.keyword = this.searchVal
        }
        if (this.typeVal !== '') {
          params.type = this.typeVal
        }
        const res = await getTrainList(params)
        if (res.data.code === 200 || res.data.code === 0) {
          const data = res.data.data
          this.tableData = data.list || []
          this.total = data.total || 0
        } else {
          this.$Message.error(res.data.message || '获取数据失败')
        }
      } catch (error) {
        this.$Message.error('获取数据失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch () {
      this.currentPage = 1
      this.getList()
    },

    // 分页
    handlePageChange (page) {
      this.currentPage = page
      this.getList()
    },

    handlePageSizeChange (size) {
      this.pageSize = size
      this.currentPage = 1
      this.getList()
    },

    // 显示新增模态框
    showAddModal () {
      this.formModal.visible = true
      this.formModal.title = '新增培训鉴定'
      this.formModal.isEdit = false
      this.formData = {
        id: null,
        trainname: '',
        trainaddress: '',
        latitude: '',
        longitude: '',
        code: '',
        content: '',
        linkman: '',
        type: 0,
        phone: '',
        flag: 0
      }
    },

    // 显示编辑模态框
    showEditModal (row) {
      this.formModal.visible = true
      this.formModal.title = '编辑培训鉴定'
      this.formModal.isEdit = true
      this.formData = {
        id: row.id,
        trainname: row.trainname,
        trainaddress: row.trainaddress,
        latitude: row.latitude,
        longitude: row.longitude,
        code: row.code,
        content: row.content,
        linkman: row.linkman,
        type: String(row.type),
        phone: row.phone,
        flag: row.flag
      }
    },

    // 提交表单
    handleSubmit () {
      this.$refs.trainForm.validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请检查表单填写')
          return
        }

        this.formModal.loading = true
        try {
          const submitData = {
            trainname: this.formData.trainname,
            trainaddress: this.formData.trainaddress,
            latitude: this.formData.latitude,
            longitude: this.formData.longitude,
            code: this.formData.code,
            content: this.formData.content,
            linkman: this.formData.linkman,
            type: this.formData.type,
            phone: this.formData.phone,
            flag: this.formData.flag
          }

          let res
          if (this.formModal.isEdit) {
            res = await updateTrain({ ...submitData, id: this.formData.id })
          } else {
            res = await createTrain(submitData)
          }

          if (res.data.code === 200 || res.data.code === 0) {
            this.$Message.success(this.formModal.isEdit ? '修改成功' : '添加成功')
            this.formModal.visible = false
            this.getList()
          } else {
            this.$Message.error(res.data.message || '操作失败')
          }
        } catch (error) {
          this.$Message.error('操作失败: ' + error.message)
        } finally {
          this.formModal.loading = false
        }
      })
    },

    // 重置表单
    handleReset () {
      this.$refs.trainForm.resetFields()
    },

    // 删除
    handleDelete (row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定要删除培训鉴定"${row.trainname}"吗？`,
        onOk: async () => {
          try {
            const res = await deleteTrain({ id: row.id })
            if (res.data.code === 200 || res.data.code === 0) {
              this.$Message.success('删除成功')
              this.getList()
            } else {
              this.$Message.error(res.data.message || '删除失败')
            }
          } catch (error) {
            this.$Message.error('删除失败: ' + error.message)
          }
        }
      })
    },

    // 显示导入模态框
    showImportModal () {
      this.importModal.visible = true
      this.importModal.file = null
      this.importModal.fileName = ''
    },

    // 文件选择
    handleBeforeUpload (file) {
      const fileExt = file.name.split('.').pop().toLocaleLowerCase()
      if (fileExt === 'xlsx' || fileExt === 'xls') {
        this.importModal.file = file
        this.importModal.fileName = file.name
      } else {
        this.$Notice.warning({
          title: '文件类型错误',
          desc: '文件：' + file.name + '不是EXCEL文件，请选择后缀为.xlsx或者.xls的EXCEL文件。'
        })
      }
      return false
    },

    // 导入数据
    async handleImport () {
      if (!this.importModal.file) {
        this.$Message.warning('请选择要导入的Excel文件')
        return
      }

      const formData = new FormData()
      formData.append('file', this.importModal.file)

      this.importModal.loading = true
      try {
        const res = await importTrain(formData)
        console.log(res)
        if (res.data.code === 200 || res.data.code === 0) {
          this.$Message.success('导入成功')
          this.importModal.visible = false
          this.getList()
        } else {
          this.$Message.error(res.data.message || '导入失败')
        }
      } catch (error) {
        this.$Message.error('导入失败: ' + error.message)
      } finally {
        this.importModal.loading = false
      }
    },

    // 取消导入
    handleCancelImport () {
      this.importModal.visible = false
      this.importModal.file = null
      this.importModal.fileName = ''
    },

    // 导出数据
    async handleExport () {
      try {
        const params = {}
        if (this.searchVal) {
          params.keyword = this.searchVal
        }
        if (this.typeVal !== '') {
          params.type = this.typeVal
        }
        const res = await exportTrain(params)
        // 处理文件下载
        const blob = new Blob([res.data])
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '培训鉴定数据.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
        this.$Message.success('导出成功')
      } catch (error) {
        this.$Message.error('导出失败: ' + error.message)
      }
    },

    // 下载模板
    handleDownloadTemplate () {
      try {
        // 获取当前网址（不包含子路径）
        const baseUrl = window.location.origin
        // 拼接模板文件地址
        const templateUrl = `${baseUrl}/templates/培训鉴定信息导入模板.xlsx`
        // 创建下载链接
        const a = document.createElement('a')
        a.href = templateUrl
        a.download = '培训鉴定信息导入模板.xlsx'
        a.click()
        this.$Message.success('模板下载成功')
      } catch (error) {
        this.$Message.error('下载失败: ' + error.message)
      }
    }
  },

  mounted () {
    this.getList()
  }
}
</script>

<style lang="less" scoped>
.search-con {
  padding: 10px 0;

  .search-input {
    display: inline-block;
    margin-right: 10px;
  }

  .search-btn {
    margin-left: 5px;
  }
}

.pagination-con {
  text-align: right;
  margin-top: 15px;
}

.file-name {
  margin-top: 10px;
  color: #808695;
  font-size: 13px;
}
</style>
